import * as dateFns from 'date-fns'

export const sortByDate = <T>(ary: T[], accessFn: (item: T) => Date): T[] => {
  return ary.sort((t1, t2) => {
    const d1 = accessFn(t1)
    const d2 = accessFn(t2)

    if (dateFns.isBefore(d1, d2)) {
      return -1
    } else if (dateFns.isAfter(d1, d2)) {
      return 1
    } else {
      return 0
    }
  })
}

/**
 * Convert a number of milliseconds to a string of the form M:SS
 * @param {number} milliseconds
 * @returns {string}
 */
export const msToMinutesAndSeconds = (milliseconds: number): string => {
  const minutes = Math.floor(milliseconds / 60000)
  const seconds = Math.floor((milliseconds % 60000) / 1000)
  const secondsString = seconds.toFixed(0)
  return (secondsString === '60' ? (minutes + 1) + ':00' : minutes + ':' + (seconds < 10 ? '0' : '') + secondsString)
}

/**
 * Converts a date to MM/DD/YYYY format
 * @param date
 */
export const americanFormattedDate = (date: string | Date): string => {
  return dateFns.format(dateFns.parse(date), 'MM/DD/YYYY')
}

/**
 * Checks whether a date is properly formatted as MM/DD/YYYY.
 */
export const isValidAmericanFormattedDate = (date: string): boolean => {
  const pattern = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/
  if (!pattern.test(date)) return false

  let parsed: Date
  try {
    parsed = dateFns.parse(date)
  } catch {
    return false
  }
  // `dateFns.parse` does not actually validate that the input date is a real date,
  // e.g. Parsing 04/31/2000 will return May 1, 2000
  // So we need to compare it back to the formatted version.
  // TODO: dateFns v2 will have a formal validation method that we can leverage when that is released.
  // https://github.com/date-fns/date-fns/issues/326
  return date === dateFns.format(parsed, 'MM/DD/YYYY')
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/utils/date-helpers.ts